import { createContext, useCallback, useContext, useRef, useState } from "react";

const PlayerContext = createContext(null);

export const PlayerProvider = ({ children }) => {
  const [currentTrack, setCurrentTrack] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const playTrack = useCallback((track) => {
    setCurrentTrack((prev) => {
      if (prev && prev.id === track.id) {
        setIsPlaying((p) => !p);
        return prev;
      }
      setIsPlaying(true);
      return track;
    });
  }, []);

  const close = useCallback(() => {
    setIsPlaying(false);
    setCurrentTrack(null);
  }, []);

  return (
    <PlayerContext.Provider value={{ currentTrack, isPlaying, setIsPlaying, playTrack, close, audioRef }}>
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => useContext(PlayerContext);
